import { HttpService } from 'core/modules/network-service';
import { get } from 'lodash';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc OrderLineItemNotes defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { OrderLineItemNotesService } from 'services/orderLineItemNotes';
 *
 * // create service instance and send/cancel request
 * const orderLineItemNotesService = new OrderLineItemNotesService();
 * const result = await orderLineItemNotesService.fetchData( '<user-id>' ); // fetch data
 * orderLineItemNotesService.cancel(); // cancel an active request
 */
export class OrderLineItemNotesService extends HttpService {

    // make request and fetch data
    async submitAddNote( { url, data } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
            };
            
        } catch( errResponse ) {
            return this._errorFormatter( errResponse );
        }
    }


    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
